﻿import { BaseWidget } from "../BaseWidget"
import { Repeater, RepeaterItem } from "./Repeater";
import { AnyElement } from "mu-widget/lib/MuWidget";
import { AWARD_CONTRACT } from "./F03_2014";

export class DropdownTender extends BaseWidget {
    private selectedIndex: number = 0;
    private showingAll: boolean = false;
    allItems: HTMLElement[] = [];
    allTenders: HTMLElement[] = [];
    itemsContainer: HTMLElement = this.container.querySelector(".dropdown-menu") as HTMLElement;

    afterIndex() {
        this.muRegisterEvent("click");
        this.container.querySelectorAll('li').forEach(item => this.allItems.push(item as HTMLElement));
        document.querySelectorAll('[mu-widget="F03_2014_AWARD_OF_CONTRACT"]').forEach(tender => this.allTenders.push(tender as HTMLElement));

        for (const item of this.allItems)
            if (item.hasAttribute("mu-id") === false) {
                item.addEventListener("click", (ev) => {
                    this.changeSelected(item);
                })
            } else {
                if (item.getAttribute("mu-id") !== "bSearchItem" && item.getAttribute("mu-id") !== "bShowAll")
                    item.addEventListener("click", ev => {
                        this.addDropdownItem();
                    })
                else if (item.getAttribute("mu-id") !== "bShowAll")
                    item.addEventListener("keypress", ev => {
                        if (ev.key == "Enter") {
                            let changed: boolean = false;
                            this.allTenders.forEach(tender => {
                                if (((tender as AnyElement).widget.ui.CONTRACT_NO.value ?? "").length !== 0 && ((tender as AnyElement).widget.ui.CONTRACT_NO.value ?? "").includes((ev.target as HTMLInputElement).value)) {
                                    this.changeSelected(this.allItems[this.allTenders.indexOf(tender)] as HTMLElement);
                                    changed = true;
                                };
                            });

                            if (changed === false) {
                                if (parseInt((ev.target as HTMLInputElement).value) < this.allItems.length - 3 && parseInt((ev.target as HTMLInputElement).value) > 0)
                                    this.changeSelected(this.allItems[parseInt((ev.target as HTMLInputElement).value) - 1])
                                else
                                    this.changeSelected();
                            }
                        }
                    })
                else
                    item.addEventListener("click", () => this.toggleShowingAll());
            }

        this.allItems[this.selectedIndex].firstElementChild.classList.add("active");
    }

    addDropdownItem(calledFromRepeater: boolean = false, label: string = "Zakázka " + (this.allItems.length - 2)) {
        const repeater: AWARD_CONTRACT = (document.querySelector('[mu-widget="AWARD_CONTRACT"]') as AnyElement).widget as AWARD_CONTRACT;
        if(calledFromRepeater === false) repeater.addItem(null, true);

        const newItem = document.createElement("li");
        newItem.style.fontSize = "14px";
        newItem.style.lineHeight = "20px";

        const itemA = document.createElement("a");
        itemA.classList.add("dropdown-item");
        itemA.innerText = label;

        newItem.appendChild(itemA);
        this.itemsContainer.insertBefore(newItem, this.allItems[this.allItems.length - 3]);

        this.allItems = [];
        this.container.querySelectorAll('li').forEach(item => this.allItems.push(item as HTMLElement));

        this.allTenders = [];
        document.querySelectorAll('[mu-widget="F03_2014_AWARD_OF_CONTRACT"]').forEach(tender => this.allTenders.push(tender as HTMLElement));

        newItem.addEventListener("click", (ev) => {
            this.changeSelected(newItem);
        });

        this.changeSelected();
    }

    changeLabel(index: number, label: string = "Zakázka " + (index + 1)) {
        if (index < this.allItems.length - 2)
            (this.allItems[index].firstElementChild as HTMLElement).innerText = label;
    }

    changeSelected(option: HTMLElement | null = null) {
        if (option == null) {
            this.allItems.forEach(item => {
                item.firstElementChild.classList.remove("active");
                this.allTenders.forEach(tender => this.hideElement(tender, this.allTenders.indexOf(tender) === this.allTenders.length - 1, false, false))
            })
            this.allItems[this.allItems.length - 4].firstElementChild.classList.add("active");
            this.ui.bTenders.innerText = (this.allItems[this.allItems.length - 4].firstElementChild as HTMLElement).innerText;
            this.toggleVisibleItems(this.allItems.length - 4);
            //(this.allTenders[this.allTenders.length - 1] as AnyElement).scrollIntoView();
        } else {
            this.allItems.forEach(item => {
                item.firstElementChild.classList.remove("active");
                this.allTenders.forEach(tender => this.hideElement(tender, this.allItems.indexOf(option) === this.allTenders.indexOf(tender), false, false))
            })
            option.firstElementChild.classList.add("active");
            this.ui.bTenders.innerText = (option.firstElementChild as HTMLElement).innerText;
            this.toggleVisibleItems(this.allItems.indexOf(option));
            //(this.allTenders[this.allItems.indexOf(option)] as AnyElement).scrollIntoView();
        }
    }

    toggleVisibleItems(index: number) {
        const allowedIndexes: number[] = [index - 2, index - 1, index, index + 1, index + 2];
        for (let i = 0; i < this.allItems.length - 3; i++) {
            if (allowedIndexes.includes(i) === true)
                this.allItems[i].classList.remove("hide-this");
            else
                this.allItems[i].classList.add("hide-this");
        }

        this.showingAll = false;
    }

    toggleShowingAll() {
        this.allItems.forEach(item => this.showingAll === true && !item.hasAttribute("mu-id") ? item.classList.add("hide-this") : item.classList.remove("hide-this"));

        if (this.showingAll === true)
            this.toggleVisibleItems(this.getCurrentlySelected());

        this.showingAll = !this.showingAll;
    }

    getCurrentlySelected(): number {
        const result = this.container.querySelector("li .active").parentElement as HTMLElement;

        return this.allItems.indexOf(result);
    }

    refreshTenders() {
        this.allTenders = [];
        document.querySelectorAll('[mu-widget="F03_2014_AWARD_OF_CONTRACT"]').forEach(tender => {
            this.allTenders.push(tender as HTMLElement);
        });
    }

    refresh() {
        this.removeAllItems();
        this.addFunctionButtons();
        document.querySelectorAll('[mu-widget="F03_2014_AWARD_OF_CONTRACT"]').forEach(tender => {
            this.allTenders.push(tender as HTMLElement);
            this.addDropdownItem(true, ((tender as AnyElement).widget.ui.CONTRACT_NO.value ?? "").length > 0 ? "Zakázka č. " + (tender as AnyElement).widget.ui.CONTRACT_NO.value : "Zakázka " + (this.allItems.length - 2))
        });

        this.changeSelected(this.allItems[0]);
    }

    addFunctionButtons() {
        const showItem = document.createElement("li");
        showItem.style.fontSize = "14px";
        showItem.style.lineHeight = "20px";
        showItem.setAttribute("mu-id", "bShowAll");
        showItem.addEventListener("click", this.toggleShowingAll);

        const showA = document.createElement("a");
        showA.classList.add("dropdown-item");
        showA.style.textAlign = "center";
        showA.innerText = "Zobrazit Všechny";

        showItem.appendChild(showA);

        const addItem = document.createElement("li");
        addItem.style.fontSize = "14px";
        addItem.style.lineHeight = "20px";
        addItem.setAttribute("mu-id", "bAddDropdownItem");
        addItem.addEventListener("click", () => this.addDropdownItem());

        const itemA = document.createElement("a");
        itemA.classList.add("dropdown-item");
        itemA.innerHTML = '<span class="material-symbols-outlined">add_circle</span>Přidat další';

        addItem.appendChild(itemA);

        const searchItem = document.createElement("li");
        searchItem.style.fontSize = "14px";
        searchItem.style.lineHeight = "20px";
        searchItem.setAttribute("mu-id", "bSearchItem");
        searchItem.addEventListener("keypress", ev => {
            if (ev.key == "Enter") {
                let changed: boolean = false;
                this.allTenders.forEach(tender => {
                    if (((tender as AnyElement).widget.ui.CONTRACT_NO.value ?? "").length !== 0 && ((tender as AnyElement).widget.ui.CONTRACT_NO.value ?? "").includes((ev.target as HTMLInputElement).value)) {
                        this.changeSelected(this.allItems[this.allTenders.indexOf(tender)] as HTMLElement);
                        changed = true;
                    };
                });

                if (changed === false) {
                    if (parseInt((ev.target as HTMLInputElement).value) < this.allItems.length - 1 && parseInt((ev.target as HTMLInputElement).value) > 0)
                        this.changeSelected(this.allItems[parseInt((ev.target as HTMLInputElement).value) - 1])
                    else
                        this.changeSelected();
                }
            }
        });

        const searchInput = document.createElement("input");
        searchInput.type = "text";
        searchInput.classList.add("form-control");
        searchInput.classList.add("dropdown-item");
        searchInput.placeholder = "Přejít na";

        searchItem.appendChild(searchInput);

        this.itemsContainer.appendChild(showItem);
        this.itemsContainer.appendChild(addItem);
        this.itemsContainer.appendChild(searchItem);

        this.container.querySelectorAll("li").forEach(item => this.allItems.push(item));
    }

    selectNext() {
        const index: number = this.getCurrentlySelected();

        if (index < this.allItems.length - 4)
            this.changeSelected(this.allItems[index + 1]);
    }

    selectPrevious() {
        const index: number = this.getCurrentlySelected();

        if (index > 0)
            this.changeSelected(this.allItems[index - 1]);
    }

    removeAllItems() {
        this.container.querySelectorAll("li").forEach(item => item.remove());
        this.allItems = [];
    }

    removeItem(index: number) {
        if (this.allItems[index] != null) {
            if (this.allItems[index].firstElementChild.classList.contains("active") === true)
                this.changeSelected(this.allItems[index - 1]);

            this.allItems[index].remove();
            this.allTenders[index].remove();

            this.refreshTenders();

            this.allItems = [];
            this.container.querySelectorAll('li').forEach(item => this.allItems.push(item as HTMLElement));
        }
    }

    bNext_click() {
        this.selectNext();
    }

    bPrevious_click() {
        this.selectPrevious();
    }

    override muFetchData(): string[] {
        return null;
    }

    override muBindData(value: string | null): void {

    }
}